<div class="marv_rating"
    [class.big]="this.size === 'big'"
    [class.small]="this.size === 'small'"
    >
    @for(rating of this.ratings; track $index){
        <div class="marv_rating_value"
            [class.selected]="this.ratingValue !== null && rating <= this.ratingValue"
            (click)="this.selectRating(rating)"
            >
            <ion-icon name="star"></ion-icon>
        </div>
    }
</div>